import { Provider, inject } from "mobx-react";
import * as React from "react";
import { RouterStore } from "mobx-react-router";
import { match, Route, RouteProps, Switch } from "react-router-dom";

import PageStore from "app/PageStore";
import { PageLoading, NotFound } from "components/Layout";

import NewsService from "./NewsService";
import NewsStore from "./NewsStore";

const NewsPage = React.lazy(() => import("./views/NewsPage"));

interface RoutesProps {
  parentPath: string;
  match: match<{}>;
  pageStore?: PageStore;
  routerStore?: RouterStore;
}

@inject("pageStore", "routerStore")
class Routes extends React.Component<RoutesProps> {
  private stores = {};

  constructor(props: RoutesProps) {
    super(props);

    const newsService = new NewsService();
    const newsStore = new NewsStore(
      props.pageStore!,
      props.routerStore!,
      newsService,
    );
    this.stores = {
      newsStore,
    };
  }

  public render() {
    const matchedUrl = this.props.match.url;
    return (
      <React.Suspense fallback={<PageLoading />}>
        <Provider {...this.stores}>
          <Switch>
            <Route path={`${matchedUrl}/:id`} render={this.renderNews} />
            <Route exact path={matchedUrl} render={this.renderNews} />
            <Route component={NotFound} />
          </Switch>
        </Provider>
      </React.Suspense>
    );
  }

  private renderNews = (routerProps: RouteProps) => (
    <NewsPage
      {...routerProps}
      trail={[
        {
          name: "News",
          url: "/",
        },
      ]}
    />
  );
}

export default Routes;
